const FILE_ICONS = {
    audio: 'AudioIcon',
    excel: 'ExcelIcon',
    image: 'ImageIcon',
    pdf: 'PDFIcon',
    ppt: 'PPTIcon',
    text: 'TextIcon',
    video: 'VideoIcon',
    word: 'WordIcon',
    zip: 'ZipIcon',
};
export const BYTES_IN_KILOBYTE = 1000;
export const FILE_SIZE = {
    byte: 'B',
    kilobyte: 'KB',
    megabyte: 'MB',
    gigabyte: 'GB',
};
export const FILE_MIMETYPE_MAPPING = {
    'audio/mpeg': FILE_ICONS.audio,
    'video/quicktime': FILE_ICONS.audio,
    'application/vnd.ms-excel': FILE_ICONS.excel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': FILE_ICONS.excel,
    'image/gif': FILE_ICONS.image,
    'image/jpeg': FILE_ICONS.image,
    'image/png': FILE_ICONS.image,
    'image/tiff': FILE_ICONS.image,
    'image/svg+xml': FILE_ICONS.image,
    'image/bmp': FILE_ICONS.image,
    'image/x-rgb': FILE_ICONS.image,
    'image/eps': FILE_ICONS.image,
    'application/postscript': FILE_ICONS.image,
    'application/pdf': FILE_ICONS.pdf,
    'application/vnd.ms-powerpoint': FILE_ICONS.ppt,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': FILE_ICONS.ppt,
    'text/plain': FILE_ICONS.text,
    'video/mp4': FILE_ICONS.video,
    'video/x-msvideo': FILE_ICONS.video,
    'application/msword': FILE_ICONS.word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': FILE_ICONS.word,
    'text/csv': FILE_ICONS.excel,
    'application/zip': FILE_ICONS.zip,
    'application/x-rar-compressed': FILE_ICONS.zip,
};
